import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'DismissLayer',
  props: {
    visible: { type: Boolean },
    zIndex: { default: 1000 }
  },
  emits: ["dismiss"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.visible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "ui-dismiss-layer",
          style: _normalizeStyle({ zIndex: String(__props.zIndex) }),
          "aria-hidden": "true",
          onPointerdown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (emit('dismiss')), ["stop"]))
        }, null, 36 /* STYLE, NEED_HYDRATION */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})